<template>
  <div class="marketing TopHeadder">
      <!-- 智能营销 -->
      <div class="bannerBox">
          <img src="../../assets/image/e_banner.png" />
           <div class="bannerTitle">
             <h3>企业客服系统iService</h3>
             <p>服务客户提升满意，洞察客户挖掘价值</p>
          </div>
      </div>
      
     <div class="qy_title">
        <ul>
            <li :class="{active1:activeChild1==1}" v-on:click="activeTab1(1)">
                <i class="qytitle_1"></i>
                <p>客服呼叫中心系统</p>
            </li>
            <li :class="{active1:activeChild1==2}" v-on:click="activeTab1(2)">
                <i class="qytitle_2"></i>
                <p>智能客服对话平台</p>
            </li>
        </ul>
     </div>
     <div class="qy" v-show="activeChild1==1">
         <div class="market_item1 PublicPadding">
            <h4 class="title">产品介绍</h4>
            <p>客服呼叫中心系统——易捷客iService，将计算机电话集成、自动语音导航、自动电话分配、客户关系管理、报表统计分析、电话录音、自动批量外呼等十余种技术和软件应用融于一体，为用户提供稳定、便捷、高效的客户呼叫中心服务能力，并支持web+电话+微信+APP+微博+邮件等全渠道一站式接入，可根据企业不同需求，提供定制化客服呼叫中心解决方案。</p>
            <i><img src="../../assets/image/qy1_1.png"/></i>
         </div>
         <div class="market_item3 PublicPadding">
          <h4 class="title">功能亮点</h4>
          <ul>
             <li class="m3_li1" :class="{active:activeChild==1}" v-on:click="activeTab(1)">
               <div>
                  <i></i>
                  <h3>全渠道客服接入</h3>
               </div>
             </li>
             <li class="m3_li2" :class="{active:activeChild==2}" v-on:click="activeTab(2)">
               <div>
                  <i></i>
                  <h3>专业级呼叫中心</h3>
                </div>
             </li>
             <li class="m3_li3" :class="{active:activeChild==3}" v-on:click="activeTab(3)">
                <div>
                  <i></i>
                  <h3>通话与工单结合</h3>
                </div>
             </li>
             <li class="m3_li4" :class="{active:activeChild==4}" v-on:click="activeTab(4)">
               <div>
                  <i></i>
                  <h3>服务监控与分析</h3>
                </div>
             </li>
      
             
          </ul>
          <ol>
             <li v-show="activeChild==1">
                <div>
                   <h3>全渠道客服接入</h3>
                   <p>整合微信、微博、电话等多渠道沟通诉求，无需切换页面，统一工作台响应客户服务，提升工作效率。</p>    
                </div>
                <i>
                  <img src="../../assets/image/qy1_2_1.png"/>
                </i>
             </li>
              <li v-show="activeChild==2">
                <div>
                   <h3>专业级呼叫中心</h3>
                   <p>利用成熟的通信技术条件，实现各类齐全的呼叫处理和操作，满足实现多种服务功能的要求：自动语音导航、话务ACD排队、主叫识别功能、人工坐席管理、通话录音/质检</p>   
                </div>
                <i>
                  <img src="../../assets/image/qy1_2_2.jpg"/>
                </i>
             </li>
             <li v-show="activeChild==3">
                <div>
                   <h3>通话与工单结合</h3>
                   <p>来电弹屏：来电自动弹出客户信息及通话历史等;</p>
                   <p>来电转接与协助：来电可一键转接到其他同事/部门，并支持三方通话;</p> 
                   <p>工单流转：一张工单统一管理多渠道服务，且支持电话自动转工单，进展全流程可见。</p>     
                </div>
                <i>
                  <img src="../../assets/image/qy1_2_3.jpg"/>
                </i>
             </li>
              <li v-show="activeChild==4">
               <div>
                   <h3>服务监控与分析</h3>
                   <p>多维度统计报表与监控：实时监控坐席呼叫指标，并以清晰直观的图标展现；</p> 
                   <p>可视化大屏监控：通话数据多维展示在大屏之上，让数据跃然眼前。</p>     
                </div>
                <i>
                  <img src="../../assets/image/qy1_2_4.jpg"/>
                </i>
             </li>
          
          </ol>
      </div>
       <div class="home_item2 PublicPadding">
        <h4 class="title">产品优势</h4>
        <ul class="clear">
            <li>
                <i><img src="../../assets/image/qy1_3_1.png"/></i>
                <h3>近20年案例积累</h3>
                <p>丰富的成功案例积累，深度扎根行业特质，满足企业不同需求</p>
            </li>
             <li>
                <i><img src="../../assets/image/qy1_3_2.png"/></i>
                <h3>定制化解决方案</h3>
                <p>根据企业个性化功能需求，提供定制化解决方案，本地部署成熟稳定，安全性更强</p>
            </li>
             <li>
                <i><img src="../../assets/image/qy1_3_3.png"/></i>
                <h3>强大的可扩展性</h3>
                <p>系统支持建制不同规模、组网方式的呼叫中心应用，各功能部件模块化，支持二次开发，方便新业务添加</p>
            </li>
             <li>
                <i><img src="../../assets/image/qy1_3_4.png"/></i>
                <h3>便捷的服务保障</h3>
                <p>细致入微的本地化开发与服务保障，提供全天候（24*7）的热线技术支持服务</p>
            </li>
        </ul> 
       </div>
       <div class="qy1_item PublicPadding colorbg">
           <h4 class="title">客户案例</h4>
           <ul>
              <li class="qy1_li1" :class="{active2:activeChild2==1}" v-on:click="activeTab2(1)">
                 <i><img src="../../assets/image/qy1_3-1.png"/></i>
                 <p>浙大中控</p>
              </li>
              <li class="qy1_li2" :class="{active2:activeChild2==2}" v-on:click="activeTab2(2)">
                 <i><img src="../../assets/image/qy1_3-2.png"/></i>
                 <p>博圣生物</p>
              </li>
              <li class="qy1_li3" :class="{active2:activeChild2==3}" v-on:click="activeTab2(3)">
                 <i><img src="../../assets/image/qy1_3-3.png"/></i>
                 <p>火星人</p>
              </li>
              <li class="qy1_li4" :class="{active2:activeChild2==4}" v-on:click="activeTab2(4)">
                 <i><img src="../../assets/image/qy1_3-4.png"/></i>
                 <p>国网平阳电力</p>
              </li>
           </ul>
           <ol>
             <li v-show="activeChild2==1">
                  <div class="qy1_lit">
                      <h3>客户简介</h3>
                      <p>
                          浙大中控是中国自动化、信息化和智能化技术、软件与解决方案供应商，业务涉及流程工业自动化及智能制造、智慧城市及智能交通、工业大数据、工控安全、科教仪器等众多领域。全球员工超过3100人，连续八年DCS国内市场占有率排名居首，承接诸多亚洲乃至全球大型项目。
                      </p>
                  </div>
                  <div class="qy1_lit">
                      <h3>解决方案</h3>
                      <p>
                          通过全渠道客服接入，整合了浙大中控官网、微信公众号、自有APP、400热线等客服渠道，一个平台统一处理客户问题，提高客户体验和满意度。同打通与中控ERP系统对接，同步工单诉求、合同信息等，实现更高效快捷地为客户提供服务。
                      </p>
                  </div>

             </li>
             <li v-show="activeChild2==2">
                <div class="qy1_lit">
                    <h3>客户简介</h3>
                    <p>
                        博圣生物是提供出生缺陷防控一站式综合解决方案的专业机构，以遗传病筛查和诊断技术为基础，集大医学遗传领域项目运营、研发、销售与学科服务、患儿救助于一体的
                        “出生缺陷防控”综合服务运营商，是中国出生缺陷防控领域践行者。
                    </p>
                </div>
                <div class="qy1_lit">
                    <h3>解决方案</h3>
                    <p>
                        博圣生物采用多渠道服务接入功能，将公众号、400热线等渠道统一管理，并将工单信息与博圣生物原有ERP系统打通，实现客户信息与工单管理的同步管理。
                    </p>
                </div>
             </li>
             <li v-show="activeChild2==3">
                <div class="qy1_lit">
                    <h3>客户简介</h3>
                    <p>
                        浙江火星人厨具有限公司是以厨房电器研发、制造和销售为核心业务的现代化科技企业，总投资逾亿元，打造产业航母。致力“为人类提供健康和谐的家庭环境”的使命，以创新的商业模式和独特的经营方式，构建“火星人”的品牌战略，励志成为中国健康厨房领航品牌,引领行业风潮。
                    </p>
                </div>
                <div class="qy1_lit">
                    <h3>解决方案</h3>
                    <p>
                        火星人采用易捷客客服呼叫中心，通过自动语音导航、智能分配客服、知识库等一系列功能，将客服资源充分利用，高效处理客户问题。并利用易捷客工单系统，统一跟进管理客户咨询、投诉、保修等问题，提升客服工作满意度。
                    </p>
                </div>
             </li>
             <li v-show="activeChild2==4">
                <div class="qy1_lit">
                    <h3>客户简介</h3>
                    <p>
                        国网浙江平阳县供电有限责任公司是浙江省电力公司的全资子公司，系原国家电力部直属县级供电企业，担负着平阳县16个乡镇的供用电管理任务。2018年，电网最高负荷73.91万千瓦，售电量累计34.71亿千瓦时，是国家电网公司五星级乡镇供电所、省一流供电企业。
                    </p>
                </div>
                <div class="qy1_lit">
                    <h3>解决方案</h3>
                    <p>
                        根据平阳电力的实际业务情况和个性化需求，进行了系统的定制化开发，通过全媒体接入、智能分配客服、知识库、坐席监控管理等一系列产品功能，做到问答咨询、业务办理、追踪反馈智能化高效化，全方位提升客服工作效率。
                    </p>
                </div>
             </li>
           </ol>
       </div>

     </div>  
     <div class="qy qy2" v-show="activeChild1==2">
          <div class="market_item1 PublicPadding">
            <h4 class="title">产品介绍</h4>
            <p>智能客服对话平台整合了语音识别、语义理解等百度AI技术，是一款主要服务于客服场景的智能对话配置管理平台。它解决了企业客服业务中重复繁琐、高人力成本等问题，无论是在线咨询、坐席辅助、营销推广还是内部管理等场景均可替代人力，智能化解决业务咨询与办理等相关事务。通过对用户表述的智能解析，利用不同对话引擎高精度匹配，并通过智能会话中控，确保对话回复的准确性。它一方面可以与业务系统对接，另一方面直接针对全渠道用户终端输出，真正形成企业与客户、企业与员工进行业务咨询与办理的桥梁。</p>
            <i><img src="../../assets/image/qy2_2.png"/></i>
          </div>
          <div class="qy2_item2 PublicPadding">
             <h4 class="title">产品功能</h4>
               <ul>
                  <li class="qy2_li1">
                      <h3>任务式会话</h3>
                      <p> 领先的多轮会话技术，根据客户意图，精准回复支持自定义变量，流程可复用，灵活的节点可视化配置</p>
                  </li>
                  <li class="qy2_li2">
                      <h3>问答</h3>
                      <p>高精度语义模型，多渠道多类型答案响应不同场景问答模板、动态问答等减少扩展问和答案维护工作量</p>
                  </li>
                  <li class="qy2_li3">
                      <h3>知识图谱</h3>
                      <p>结构化知识生产和管理，可对全文进行解析和检索知识推理，让对话更智能</p>
                  </li>
                  <li class="qy2_li4">
                      <h3>闲聊</h3>
                      <p>预置生成式闲聊结合自定义闲聊话术，贴心话语常伴客户左右</p>
                  </li>
              </ul>

          </div>
           <div class="home_item2 PublicPadding">
              <h4 class="title">产品优势</h4>
              <ul class="clear">
                  <li>
                      <i><img src="../../assets/image/qy2_3_1.png"/></i>
                      <h3>流程可视</h3>
                      <p>可视化的会话流程配置，降低使用门槛，配置流程更易理解</p>
                  </li>
                  <li>
                      <i><img src="../../assets/image/qy2_3_2.png"/></i>
                      <h3>对话拟人</h3>
                      <p>输出回复不呆板，拟人化对话服务客户更贴心</p>
                  </li>
                  <li>
                      <i><img src="../../assets/image/qy2_3_3.png"/></i>
                      <h3>运营便捷</h3>
                      <p>丰富运营工具助力知识的导入、管理和统计，提升会话能力，降低运营成本</p>
                  </li>
                  <li>
                      <i><img src="../../assets/image/qy2_3_4.png"/></i>
                      <h3>渠道全面</h3>
                      <p> 移动端、PC端多渠道统一管理，同时支持差异化运营</p>
                  </li>
              </ul> 
           </div>
           <div class="qy2_item3 PublicPadding colorbg">
              <h4 class="title">使用场景</h4>
              <ul>
                 <li>
                    <h3>智能在线客服</h3>
                    <i><img src="../../assets/image/qy2_4_1.png"/></i>
                    <p>构建兼具任务式会话和问答能力的7x24小时客服，高频重复问题一网打尽，低频长尾问题转交人工</p>
                 </li>
                 <li>
                    <h3>智能IVR/智能语音客服/智能外呼</h3>
                    <i><img src="../../assets/image/qy2_4_2.png"/></i>
                    <p>智能语音导航根据客户意图快速引导，智能分流来电诉求；或构建智能外呼系统，批量触达潜在客户</p>
                 </li>
                 <li>
                    <h3>人机协同/客服产品矩阵</h3>
                    <i><img src="../../assets/image/qy2_4_3.png"/></i>
                    <p>利用语义和对话能力搭建综合人机协同客服系统，建立智能质检、客服助手和培训一站式解决方案</p>
                 </li>

              </ul>

           </div>
     </div>   
  

     
     
      <Popup v-show="$store.state.isshow"></Popup>
  </div> 
</template>

<script>
import Popup from "@/components/popup"
export default {
  name: 'marketing',
  data () {
    return {
        activeChild1:1,
        activeChild2:1,
        activeChild:1,
      
    }
  },
  components:{
        Popup
  },
  methods:{
    popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    },
    activeTab1(num) {
       this.activeChild1=num
    },
    activeTab(num) {
       this.activeChild=num
    },
     activeTab2(num) {
       this.activeChild2=num
    },
  }
}
</script>


<style scoped>
.audioBox{display: none;}
.qy_title ul{
    overflow: hidden;
}
.qy_title ul li{
  float: left;
  width: 3.75rem;
  height: 0.9rem;
  background: #e5f9ff;
  overflow: hidden;
}
.qy_title ul li i{
  float: left;
  width: 0.35rem;
  height: 0.35rem;
  margin: 0.3rem 0.13rem 0 0.68rem;

}
.qy_title ul li .qytitle_1{
   background: url("../../assets/image/qyt_11.png") no-repeat center;
   background-size:100% 100%;
}
.qy_title ul li .qytitle_2{
   background: url("../../assets/image/qyt_22.png") no-repeat center;
   background-size:100% 100%;
}
.qy_title ul li.active1{
  background: #00c7ff;
}
.qy_title ul li.active1 .qytitle_1{
   background: url("../../assets/image/qyt_1.png") no-repeat center;
   background-size:100% 100%;
}
.qy_title ul li.active1 .qytitle_2{
   background: url("../../assets/image/qyt_2.png") no-repeat center;
   background-size:100% 100%;
}
.qy_title ul li p{
  float: left;
  font-size: 0.22rem;
  color: #00C7FF;
  line-height: 0.9rem;
}
.qy_title ul li.active1 p{
  color: #fff;
}
.market_item1{
  padding-left:0.25rem;
  padding-right:0.25rem;
}
.market_item1 p{
  font-size: 0.2rem;
  font-weight: 400;
  color: #666666;
  line-height: 0.4rem;
  padding: 0.4rem;
  box-shadow: 0 0 0.08rem #ccc;
  margin-top:0.5rem;
  margin-bottom: 0.7rem;
}
.market_item1 i{
  display: block;
  width:7rem;
  height: 12.72rem;
}
.market_item1 i img{
  display: block;
  width:7rem;
  height: 12.72rem;
}
.qy2 .market_item1 i{
  height: 13.14rem;
}
.qy2 .market_item1 i img{
  height: 13.14rem;
}
.market_item3{
  background:url("../../assets/image/qy2_bg.png") no-repeat center;
  background-size:100% 100%;
  width: 7.5rem;
  height: 7.06rem;
}
.market_item3 ul{
  /* overflow: hidden; */
  width: 7rem;
  height: 1.5rem;
  margin: 0 auto;
  /* border-top:0.02rem solid #90e4f7;
  border-bottom:0.02rem solid #90e4f7; */
  margin-top:0.4rem;
}
.market_item3 .title{
  color: #fff;
}
.market_item3 ul li{
  float: left;
  width: 1.67rem;
  margin-right: 0.1rem;
  background: #eefefc;
}
.market_item3 ul li:last-child{
    margin-right: 0rem;
}
.market_item3 ul li div{
  height: 1.1rem;
  border-left: 0.01rem solid #90e4f7;
  padding-top: 0.2rem;
}
.market_item3 ul li.active{
  padding-bottom:0.2rem ;
}
.market_item3 ul li:first-child div{
  border-left: none;
}
.market_item3 ul li i{
  display: block;
  width: 0.3rem;
  height: 0.3rem;
  margin: 0 auto; 
  margin-bottom: 0.17rem;
}
.market_item3 ul li.m3_li1 i{
   background: url("../../assets/image/qy1_2-1.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li2 i{
   background: url("../../assets/image/qy1_2-2.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li3 i{
   background: url("../../assets/image/qy1_2-3.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li4 i{
   background: url("../../assets/image/qy1_2-4.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li1.active i{
   background: url("../../assets/image/qy1_2-11.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li2.active i{
   background: url("../../assets/image/qy1_2-22.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li3.active i{
   background: url("../../assets/image/qy1_2-33.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li4.active i{
   background: url("../../assets/image/qy1_2-44.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li h3{
  font-size: 0.18rem;
  font-weight: 400;
  color: #333;
  line-height: 0.3rem;
  width: 1.6rem;
  margin: 0 auto;
}
.market_item3 ul li.active{
  background:url("../../assets/image/m_li.png") no-repeat center;
  background-size:100% 100%;
}
.market_item3 ul li.active h3{
  color: #fff;
}
.market_item3 ol{
  width: 7rem;
  height: 4.56rem; 
  margin:0 auto;
  margin-top: 0.1rem;
  box-shadow: 0 0 0.08rem #ccc;
  background: #fff;
}
.market_item3 ol li{
  overflow: hidden;
}
.market_item3 ol li div{
  float: left;
}
.market_item3 ol li div h3{
  font-size: 0.3rem;
  font-weight: 400;
  color: #33CAF2;
  line-height: 0.3rem;
  margin: 0.8rem 0 0.3rem 0.3rem;
}
.market_item3 ol li div p{  
  font-size: 0.18rem;
  font-weight: 400;
  color: #666666;
  margin-top:0.1rem;
  margin-left: 0.3rem;
  width: 2.9rem;
}
.market_item3 ol li i{
  float: right;
  display: block;
  width:3.42rem;
  height: 3.82rem;
  margin:0.35rem 0.26rem 0 0;
}
.market_item3 ol li i img{
  display: block;
  width:3.68rem;
  height: 3.68rem;
}
.home_item2 ul{
  margin-top: 0.4rem;
}
.home_item2 ul li{
    float: left;
    width: 3.2rem;
    height: 4.3rem;
    box-shadow: 0px 0px 0.05rem 0.01rem rgba(0, 0, 0, 0.17);
    margin: 0.2rem 0.2rem 0.2rem 0.3rem;
    background: #fff;
}
.home_item2 ul li i{
    display: block;
    width: 1.17rem;
    height: 1.1rem;
    margin: 0 auto;
    margin-top: 0.44rem;
}
.home_item2 ul li i img{
    display: block;
    width: 1.17rem;
    height: 1.1rem;
}
.home_item2 ul li h3{
    font-size: 0.24rem;
    color: #333;
    font-weight: 400;
    text-align: center;
    margin: 0.15rem 0 0.37rem 0;
}
.home_item2 ul li p{
    width: 2.8rem;
    font-size: 0.2rem;
    color: #999;
    line-height: 0.36rem;
    text-align: center;
    margin: 0 auto;
}
.qy1_item ul{
   overflow: hidden;
   margin: 0.4rem 0.1rem 0 0.2rem;
}
.qy1_item ul li{
  float: left;
  width: 1.7rem;
  height: 1.3rem;
  background: #fff;
  margin-right: 0.1rem;
}
.qy1_item ul li.active2{
  border-bottom: 0.04rem solid #33caf2;
}
.qy1_item ul li.qy1_li1 i{
  display: block;
  width: 1.5rem;
  height: 0.36rem;
  margin: 0 auto;
  padding-top: 0.3rem;
  margin-bottom: 0.1rem;
}
.qy1_item ul li.qy1_li1 i img{
  display: block;
  width: 1.5rem;
  height: 0.36rem;
}
.qy1_item ul li.qy1_li2 i{
  display: block;
  width: 0.61rem;
  height: 0.49rem;
  margin: 0 auto;
  padding-top: 0.2rem;
  margin-bottom: 0.1rem;
}
.qy1_item ul li.qy1_li2 i img{
  display: block;
  width: 0.61rem;
  height: 0.49rem;
}
.qy1_item ul li.qy1_li3 i{
  display: block;
  width: 0.59rem;
  height: 0.57rem;
   margin: 0 auto;
   padding-top: 0.15rem;
  margin-bottom: 0.1rem;
}
.qy1_item ul li.qy1_li3 i img{
  display: block;
  width: 0.59rem;
  height: 0.57rem;
}
.qy1_item ul li.qy1_li4 i{
  display: block;
  width: 0.65rem;
  height: 0.65rem;
   margin: 0 auto;
   padding-top: 0.1rem;
  margin-bottom: 0.07rem;
}
.qy1_item ul li.qy1_li4 i img{
  display: block;
  width: 0.65rem;
  height: 0.65rem;
}
.qy1_item ul li p{
  font-size: 0.2rem;
  color: #333333;
  line-height: 0.3rem;
  text-align: center;
}
.qy1_item  ol{
  margin-top:0.4rem;
  padding: 0 0.3rem;
  height: 4.8rem;
}
.qy1_item  ol li .qy1_lit{
    margin-bottom:0.5rem;
}
.qy1_item  ol li .qy1_lit h3 {
    font-size: 0.18rem;
    font-weight: 400;
    color: #333333;
    padding-left: 0.1rem;
    border-left: 0.04rem solid #33caf2;
}
.qy1_item  ol li .qy1_lit p {
    font-size: 0.14rem;
    color: #999;
    line-height: 0.32rem;
    margin-top:0.3rem;
    width:6.8rem;
}

.qy2_item2{
  background: url("../../assets/image/qy2_2_bg.png") no-repeat center;
  background-size:100% 100%;
  height: 8.24rem;
}
.qy2_item2 .title{
  color: #fff;
}
.qy2_item2 ul {
    width: 3.95rem;
    height: 4.01rem;
    margin:1.7rem auto;
    background: url("../../assets/image/qy2_2_1.png") no-repeat center;
    background-size:100% 100%;
    position: relative;
}
.qy2_item2 ul .qy2_li1 {
    position: absolute;
    left: -1.6rem;
    top: -1rem;
}
.qy2_item2 ul .qy2_li1 h3 {
    text-align: right;
}
.qy2_item2 ul .qy2_li1 p {
    text-align: right;
  
}
.qy2_item2 ul li {
    width: 1.4rem;
}
.qy2_item2 ul li h3 {
    font-size: 0.2rem;
    color: #fff;
    font-weight: 400;
    margin-bottom: 0.16rem;
}
.qy2_item2 ul li p {
    /* width: 1.2rem; */
    font-size:0.14rem;
    color: #fff;
    opacity: 0.57;
}
.qy2_item2 ul .qy2_li2 {
    position: absolute;
    right: -1.6rem;
    top: -1rem;
}
.qy2_item2 ul .qy2_li3 {
    position: absolute;
    left: -1.3rem;
    bottom: -1.3rem;
}

.qy2_item2 ul .qy2_li3 h3 {
    text-align: right;
}

.qy2_item2 ul .qy2_li3 p {
    text-align: right;
}
.qy2_item2 ul .qy2_li4 {
    position: absolute;
    right: -1.4rem;
    bottom: -1rem;
}
.qy2_item3 ul{
  margin-top:0.5rem;
}
.qy2_item3 ul li{
    width: 7rem;
    background: #fff;
    margin:0 auto;
    margin-top:0.3rem;
    overflow: hidden;
}
.qy2_item3 ul li h3{
    float: left;
    width: 100%;
    font-size: 0.24rem;
    font-weight: 400;
    color: #333333;
    margin: 0.3rem 0 0.32rem 0.45rem;
}
.qy2_item3 ul li i{
    float: left;
    width: 1.15rem;
    height: 1.15rem;
    margin:0 0.23rem 0.3rem 0.38rem;
}
.qy2_item3 ul li i img{
    display: block;
    width: 1.15rem;
    height: 1.15rem;
}
.qy2_item3 ul li p{
     float: left;
    font-size: 0.2rem;
    width: 5.1rem;
    font-weight: 400;
    color: #666666;
    line-height: 0.4rem;
    margin-top:0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/product/enterPrise.vue